import React from "react";
import { useUserContext } from "context/UserContext";
import TransactionsBK from "layouts/BK/transactions";
import TransactionsCM from "layouts/CM/transactions";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function Transactions() {
  const { roleLevel } = useUserContext() || {};
  const numericRoleLevel = normalizeRoleLevel(roleLevel);
  if (isManagementRoleLevel(numericRoleLevel)) {
    return <TransactionsBK />;
  }
  if (numericRoleLevel === 4 || numericRoleLevel === 5) {
    return <TransactionsCM />;
  }
  return null;
}

export default Transactions;
